// extracted by mini-css-extract-plugin
export var container = "_f8-0";
export var icon = "_f8-1";
export var text = "_f8-2";